import { Chip } from "@mui/material";
import { SaleItem } from "../models/saleItem";
import { RestaurantHelper } from "../services/functions/restaurantHelper";
import { ShoppingBag } from '@mui/icons-material';
import { popAnimation } from "./animations/pop";

export const SupriseBagsRemaining = ({ saleItems }: { saleItems: SaleItem[] }) => {
    const total = RestaurantHelper.getTotalQuantity(saleItems);

    if (total === null || total === 0) return null;

    // Determine the background color based on total
    let backgroundColor = "#FF6F61"; // Default color (red)
    if (total > 25) {
        backgroundColor = "#A6C48A"; // Green for more than 25
    } else if (total <= 25 && total >= 15) {
        backgroundColor = "#FFD580";
    } else if (total < 10) {
        backgroundColor = "#FFA07A"; // Coral for less than 10
    }

    return (
        <Chip
            icon={<ShoppingBag style={{ color: "#000" }} />}
            label={`${total} left`}
            sx={{
                backgroundColor: backgroundColor,
                color: "#000",
                fontWeight: "bold",
                borderRadius: "16px",
                margin: "4px",
                minWidth: "200px",
                maxWidth: "200px",
                animation: total <= 25 ? `${popAnimation} 1s ease-in-out infinite` : undefined,
            }}
        />
    );
};